import styled from "styled-components";

export const Loader = styled.div`
  width: 100%;
  height: calc(100vh - 120px);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const RootContainer = styled.div`
  padding: 24px 16px;
`;

export const Top = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: #d9d9d9;
  height: 90px;
  position: relative;
  margin-top: 30px;
  border-radius: 16px;
`;

export const Image = styled.img.attrs({
  alt: "icon",
})`
  width: 62px;
  height: 62px;
  aspect-ratio: 1;
  object-fit: cover;
  border-radius: 13px;
  position: absolute;
  top: -30px;
  left: 50%;
  transform: translateX(-50%);
`;

export const Title = styled.div`
  text-align: center;
  color: #000;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  padding-left: 3px;
  padding-right: 3px;
  padding-top: 35px;
`;

export const PlayerListContainer = styled.div`
  width: 96%;
  background: #FFF;
  border-radius: 10px;
  margin-top: 16px;
  padding: 16px 8px 0px 8px;
  border: 1px solid #DEEDFF;
`;

export const PlayerBox = styled.div`
  border-bottom: 1px solid #DEEDFF;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0.5;
`;

export const NoCard = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex: 0.3;
  width: 100%;
  height: 55px;
`;

export const NoText = styled.div`
  color: #000;
  font-weight: 500;
  font-size: 16px;
`;

export const NameCard = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  flex: 1.7;
  width: 100%;
  height: 55px;
`;

export const AmountCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  flex: 1;
  width: 100%;
  height: 55px;
`;

export const NameText = styled.div`
  color: #000;
  font-size: 16px;
  font-weight: 500;
  padding-bottom: 3px;
`;

export const PhoneText = styled.div`
  color: #969696;
  font-size: 14px;
  font-weight: 400;
`;

export const AmountText = styled.div`
  color: #004F9C;
  font-size: 16px;
  font-weight: 500;
`;
